import { SVGProps } from 'react';

export default function PauseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="pause"
      width="48"
      height="48"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2 25.48V6.52C14.2 4.72 13.44 4 11.52 4H6.68C4.76 4 4 4.72 4 6.52V25.48C4 27.28 4.76 28 6.68 28H11.52C13.44 28 14.2 27.28 14.2 25.48Z"
        fill="white"
      />
      <path
        d="M28 25.48V6.52C28 4.72 27.24 4 25.32 4H20.48C18.5734 4 17.8 4.72 17.8 6.52V25.48C17.8 27.28 18.56 28 20.48 28H25.32C27.24 28 28 27.28 28 25.48Z"
        fill="white"
      />
    </svg>
  );
}
